import { isEqual } from "lodash";
import { createDirtyChecker } from "../../gvc/testNewForm/createDirtyChecker";
import { inputToGroup } from "../utils";

export function getDirtyChecker(id: string) {
  return createDirtyChecker(id, inputToGroup, (initItem, currItem, initRaw, currRaw) => {
    const dirty: Record<string, boolean> = {};
    if (!isEqual(initItem.description, currItem.description)) dirty.description = true;
    if (!isEqual(initItem.memberQuery, currItem.memberQuery)) dirty.userQuery = true;
    if (!isEqual(initItem.identityMatcher, currItem.identityMatcher)) dirty.identityMatcher = true;
    if (!isEqual(initItem.tags, currItem.tags)) dirty.tags = true;
    // Users and serviceAccounts are separate in form but merged into memberLinks in output
    if (!isEqual(initRaw.users.map((u: any) => u.link), currRaw.users.map((u: any) => u.link))) {
      dirty.users = true;
    }
    if (!isEqual(initRaw.serviceAccounts.map((s: any) => s.link), currRaw.serviceAccounts.map((s: any) => s.link))) {
      dirty.serviceAccounts = true;
    }
    return dirty;
  });
}
